import { useCallback } from 'react';
import { useRouter } from 'next/router';
import parseQueryParamsToObject from '../helpers/parseQueryParamsToObject';

const useRelativeUrl = () => {
  const router = useRouter();

  const get = useCallback(
    (queryParams: string) => {
      return {
        pathname: router.pathname,
        query: { ...router.query, ...parseQueryParamsToObject(queryParams) },
      };
    },
    [router.pathname, router.query]
  );

  return { getRelativeUrl: get };
};

export default useRelativeUrl;
